import { Container, Grid, IconButton, LinearProgress, Tooltip } from '@mui/material';
import { useState } from 'react';
import { AiFillCloseCircle } from 'react-icons/ai';

import IMedicalCertificate from '../../../interfaces/IMedicalCertificate';
import { Span, SpanTitle } from '../../followupReport/FollowupList.styled';
import { getTimeQuanitity } from '../../followupReport/followupUtil';
import moment from 'moment';
import FollowupStatus from '../../followup/FollowupStatus';

interface IProps {
  closeDialog: () => void;
  isOpen: boolean;
  medicalCertificate: IMedicalCertificate | null;
}

const ViewMedicalCertificateDialog = (props: IProps) => {
  const handleClose = () => {
    setLoading(false);
    props.closeDialog();
  };

  const [loading, setLoading] = useState(false);
  const [medicalCertificate] = useState<IMedicalCertificate | null>(props.medicalCertificate);

  const getDiseaseClassifitation = (medicalCertificate: IMedicalCertificate): string => {
    const diseaseClassification =
      medicalCertificate.diseaseClassifications && medicalCertificate.diseaseClassifications[0];
    if (diseaseClassification?.code) {
      return diseaseClassification?.code;
    }
    return ``;
  };
  return (
    <Container sx={{ paddingBottom: 4 }}>
      <Tooltip title="Fechar Visualização do Documento" placement="left">
        <IconButton onClick={handleClose}>
          <AiFillCloseCircle />
        </IconButton>
      </Tooltip>

      <Grid container spacing={2} sx={{ padding: '20px 0', flexDirection: 'column' }}>
        <Grid item lg={4} md={6} sm={12}>
          <SpanTitle>Protocolo:</SpanTitle>
          <Span>{medicalCertificate?.protocolNumber}</Span>
        </Grid>
        <Grid item lg={12} md={12} sm={12}>
          <SpanTitle>CID:</SpanTitle>
          <Span>{getDiseaseClassifitation(medicalCertificate!)}</Span>
        </Grid>
        <Grid item lg={4} md={6} sm={12}>
          <SpanTitle>Tipo de Documento:</SpanTitle>
          <Span>{medicalCertificate?.typeDocument?.description}</Span>
        </Grid>
        <Grid item lg={4} md={6} sm={12}>
          <SpanTitle>Documento Enviado:</SpanTitle>
          <Span>{moment(medicalCertificate?.createdAt).format('DD/MM/yyyy HH:mm')}</Span>
        </Grid>
        <Grid item lg={4} md={6} sm={12}>
          <SpanTitle>Data do Documento:</SpanTitle>
          <Span>{moment(medicalCertificate?.documentDate).format('DD/MM/yyyy')}</Span>
        </Grid>
        <Grid item lg={4} md={6} sm={12}>
          <SpanTitle>Tempo de Afastamento:</SpanTitle>
          <Span>{getTimeQuanitity(medicalCertificate)}</Span>
        </Grid>
        <Grid item lg={4} md={6} sm={12} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <SpanTitle>Status:</SpanTitle>
          <FollowupStatus status={medicalCertificate!.status} />
        </Grid>
      </Grid>

      {loading && <LinearProgress />}
    </Container>
  );
};

export default ViewMedicalCertificateDialog;
